import { LoversLiveForeverLogo } from "components/LoversLiveForeverLogo"
import { Link } from "react-router-dom"

export const TermsPage = () => {
  return (
    <>
      <header className="inset-x-0">
        <nav
          aria-label="Global"
          className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
        >
          <div className="flex lg:flex-1">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Lovers live forever</span>
              <LoversLiveForeverLogo className="h-20 w-auto" />
            </Link>
          </div>
        </nav>
      </header>
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms and Agreements</h1>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            1. Service Description
          </h2>
          <p className="text-gray-600 leading-relaxed">
            This website ("Service") provides users with the ability to create digital
            time capsules containing text entries that remain sealed until a specified
            future date. Users can collaborate with others by sharing access to their time
            capsules.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            2. Account Creation and Security
          </h2>
          <ul className="list-disc pl-5 space-y-2 text-gray-600">
            <li>Users must create an account using a valid email address</li>
            <li>
              Users must provide a display name and may optionally upload a profile
              picture
            </li>
            <li>
              Users are responsible for maintaining the confidentiality of their account
              credentials
            </li>
            <li>
              Users must notify us immediately of any unauthorized use of their account
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            3. Time Capsule Creation and Management
          </h2>
          <ul className="list-disc pl-5 space-y-2 text-gray-600">
            <li>
              Users can create digital time capsules and specify their opening dates
            </li>
            <li>
              Content within time capsules remains private until the designated opening
              date
            </li>
            <li>Time capsule creators can invite collaborators via email</li>
            <li>All entries are timestamped and attributed to their creators</li>
            <li>
              Upon reaching the opening date, content becomes visible to the capsule owner
              and invited collaborators
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            4. User Rights and Control
          </h2>
          <ul className="list-disc pl-5 space-y-2 text-gray-600">
            <li>Users may delete their account at any time</li>
            <li>Users may delete any time capsules they have created</li>
            <li>Users may remove themselves from shared time capsules</li>
            <li>Time capsule owners may remove other users from their shared capsules</li>
            <li>
              Account deletion will result in the removal of all user-created content
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            5. Privacy and Data Protection
          </h2>
          <ul className="list-disc pl-5 space-y-2 text-gray-600">
            <li>
              We collect and store user-provided information including email addresses,
              display names, and optional profile pictures
            </li>
            <li>
              Time capsule content is securely stored and remains private until the
              designated opening date
            </li>
            <li>
              We use email addresses solely for account-related communications and sharing
              functionality
            </li>
            <li>We implement appropriate security measures to protect user data</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            6. Age Requirements and Eligibility
          </h2>
          <ul className="list-disc pl-5 space-y-2 text-gray-600">
            <li>
              Users must be at least 16 years old to create an account and use this
              Service
            </li>
            <li>
              By creating an account, users confirm they meet the minimum age requirement
              and/or have obtained necessary parental/guardian consent according to their
              local laws
            </li>
            <li>
              Users are responsible for ensuring their use of the Service complies with
              applicable laws in their jurisdiction
            </li>
            <li>
              We reserve the right to terminate accounts if we discover users do not meet
              these requirements
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Acceptable Use</h2>
          <p className="text-gray-600 mb-3">Users agree not to:</p>
          <ul className="list-disc pl-5 space-y-2 text-gray-600">
            <li>Submit illegal or harmful content</li>
            <li>Impersonate others</li>
            <li>
              Attempt to gain unauthorized access to other users' accounts or time
              capsules
            </li>
            <li>Use the Service for any unlawful purpose</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            8. Modifications to Service
          </h2>
          <p className="text-gray-600 leading-relaxed">
            We reserve the right to modify or discontinue the Service with reasonable
            notice to users.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            9. Limitation of Liability
          </h2>
          <p className="text-gray-600 leading-relaxed">
            The Service is provided "as is" without warranties of any kind, either express
            or implied.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Governing Law</h2>
          <p className="text-gray-600 leading-relaxed">
            These terms shall be governed by and construed in accordance with applicable
            laws.
          </p>
        </section>
      </div>
    </>
  )
}
